import {
  Address,
  AddressWithOptionalCoordinates,
  BaseBulkError,
  BaseMany,
  BaseOne,
  Contact,
  CountryCodes,
  OpeningHours,
} from '@cnx-saas/common';
import { VehicleCapabilities } from '@cnx-saas/vehicles';

export type LocationInput = {
  // version: number; // NOTE: became optional
  externalReference?: string;
  owned: boolean;
  address: AddressWithOptionalCoordinates;
  company?: string;
  contact?: Contact;
  description?: string;
  loadingRequirements?: VehicleCapabilities[];
  serviceTime: number;
  openingHours: OpeningHours; // RENAMED: timeWindows, timezone, timeWindowType
};

export type Location = BaseOne &
  LocationInput & {
    tenantId: string;
    address: Address;
  };

export type Locations = BaseMany<Location>;

export type LocationImport = {
  company?: string;
  street: string;
  country: CountryCodes;
  zipCode: string;
  city: string;
  region?: string;
  externalReference: string;
  owned: boolean;
  serviceTime: number;
  contactFirstName?: string;
  contactLastName?: string;
  contactPhone?: string;
  contactEmail?: string;
  contactRole?: string;
  comments?: string;
  description?: string;
  coordinatesLat?: number;
  coordinatesLng?: number;
};

export type LocationImportWithIndex = {
  index: number;
  value: LocationImport;
};

export type PickUpLocationImport = {
  companyPickUp?: string;
  streetPickUp: string;
  countryPickUp: CountryCodes;
  zipCodePickUp: string;
  cityPickUp: string;
  ownedPickUp: boolean;
  serviceTimePickUp: number;
  contactFirstNamePickUp?: string;
  contactLastNamePickUp?: string;
  contactPhonePickUp?: string;
  contactEmailPickUp?: string;
};

export type DropOffLocationImport = {
  companyDropOff?: string;
  streetDropOff: string;
  countryDropOff: CountryCodes;
  zipCodeDropOff: string;
  cityDropOff: string;
  ownedDropOff: boolean;
  serviceTimeDropOff: number;
  contactFirstNameDropOff?: string;
  contactLastNameDropOff?: string;
  contactPhoneDropOff?: string;
  contactEmailDropOff?: string;
};

export enum LocationMasterDataInfoType {
  WithoutEmail = 'WithoutEmail',
  WithoutOpeningHours = 'WithoutOpeningHours',
  WithoutPhone = 'WithoutPhone',
}

export interface LocationMasterData {
  infoType: LocationMasterDataInfoType;
  count: number;
}

export type LocationInputWithTenantId = LocationInput & { tenantId: string };

export type LocationImportMapValidationResult = {
  locationsImportWithTenantId: LocationInputWithTenantId[];
  failedErrors: BaseBulkError[];
};
